import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { IntNodeComponent } from './Components';
import { createSelectNodeData } from '../../states/selectors/chatbotSelectors';

export const SubscriptionCheckBlock = React.memo((node) => {
  const { block, start } = useSelector(createSelectNodeData(node.id), shallowEqual);

  if (!block) {
    return null;
  }

  const { data } = block;

  return (
    <IntNodeComponent
      name="Subscription Check"
      icon="payment"
      data={data}
      node={node}
      start={start}
    />
  );
});

export const SubscriptionCheckEditor = () => {
  return (
    <>
      <div className="section">SUBSCRIPTION CHECK (System Block)</div>

      <div className="alert alert-warning mt-2" role="alert">
        <small>
          <strong>System Block</strong> — Executes automatically, no user interaction.
          <br />
          Checks if the logged-in client (via <code>chat.data.email</code>) has an active subscription.
          <br />
          Connect <strong>T</strong> (TRUE) for active subscribers and <strong>F</strong> (FALSE) for everyone else.
        </small>
      </div>
    </>
  );
};
